export const getMetadata = (metadataString) => {
  try {
    return metadataString === "" ? {} : JSON.parse(metadataString)
  } catch (error) {
    return {}
  }
}

export const isStreamingKit = () => window.location.pathname.startsWith("/streaming")
export const isInternalRole = (role) => role && role.startsWith("__internal")
